import React, { Component } from 'react'

export default class grayclose extends Component {
    render() {
        return (
          
<svg className={this.props.className} onClick={this.props.onClick} width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.9961 4L4.99609 12" stroke="#666666" strokeWidth="1.6" stroke-linecap="round" strokeLinejoin="round"/>
<path d="M4.99609 4L12.9961 12" stroke="#666666" strokeWidth="1.6" stroke-linecap="round" strokeLinejoin="round"/>
</svg>

        )
    }
}
